import { themeObject } from 'lib';
import { styled } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

const drawerWidth = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

export const StyledAppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export const styles = {
    menuToggleButton: {
        marginRight: 5,
        marginLeft: 0,
    },
    appBar: (open: boolean): any => ({
        width: `calc(100% - ${open ? '200' : '100'}px)`,
        backgroundColor: 'white',
        boxShadow: 'none',
        zIndex: 0,
    }),
    toolBar: {
        display: 'flex',
        justifyContent: 'space-between',
        py: 1,
        mr: 1,
        height: '100%',
    },
    trialCountdownContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        height: 'stretch',
        overflow: 'hidden',
    },
    settingsContainer: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
    },
    elevatingChip: {
        width: '83',
        height: '32px',
        borderRadius: '100px',
        mr: 2,
    },
    accountMenuIcon: {
        m: 0,
        p: 0,
        height: '40px',
        width: '40px',
    },
    accountMenuAvatar: {
        p: 1,
        width: 32,
        backgroundColor: themeObject.palette.tertiary.purple[400],
        height: 32,
    },
    accountMenuNavlink: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
    },
    appHeaderContainer: {
        display: 'flex',
    },
};
